var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMultiplyInline(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44.558,
    height: 44.558,
    viewBox: "0 0 44.558 44.558",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3336",
    "data-name": "Group 3336",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line_428",
    "data-name": "Line 428",
    d: "M57.112,3.936H1.968A1.968,1.968,0,1,1,1.968,0H57.112a1.968,1.968,0,0,1,0,3.936Z",
    transform: "translate(2.783 0) rotate(45)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_429",
    "data-name": "Line 429",
    d: "M57.112,3.936H1.968A1.968,1.968,0,1,1,1.968,0H57.112a1.968,1.968,0,1,1,0,3.936Z",
    transform: "translate(44.558 2.783) rotate(135)",
    fill: "#ffffff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultiplyInline);
export default __webpack_public_path__ + "static/media/multiplyInline.a821643dcef0156f8f3b03c7d7c43805.svg";
export { ForwardRef as ReactComponent };